export const SHIPPING_COST = 13;
